var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"display-2 mt-3"},[_vm._v("Page not found")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }